export enum SeverityLevel {
  Informational,
  Warning,
  Critical,
}
export default SeverityLevel;
